var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"system-information"},[_c('about-info')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }